import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { StateService } from "../services/state.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent {
  signUp: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly stateService: StateService,
  ) {}

  login() {
    this.redirectToLogin(this.stateService.apiList.user.login);
  }

  userBoarding() {
    this.signUp = !this.signUp;
  }
  // Wrapping window.location.replace in a separate method
  redirectToLogin(url: string) {
    window.location.replace(url);
  }
}
